import React from "react";

import styles from './IconTextCard.module.scss';
import {typografText} from "../../utils/typograf";
import type {IconTextCardData} from "../../types";
import H4 from "../typography/H4";
import List1 from "../typography/List1";
import {PARTNER_REGISTER_LINK} from "../../constants";
import {COLORS} from "../../../../../config/constants";

type IconTextCardProps = {
    item: IconTextCardData;
};

function IconTextCard({item}: IconTextCardProps) {

    return (
        <div className={styles.card}>
            <H4 className={styles.title} sx={{
                '@media screen and (min-width: 576px) and (max-width: 767px)': {
                    color: COLORS.BLACK,
                    overflowWrap: 'normal',
                    textWrap: 'wrap',
                },
                '@media screen and (min-width: 1200px)': {
                    display: 'flex',
                    minWidth: 0,
                    width: '100%',
                },
            }}>{item.title}</H4>
            <div className={styles.textContent}>
                <span className={`${styles.emoji} ${styles.emojiDefault}`}>
                    {item.emoji}
                </span>
                <span className={`${styles.emoji} ${styles.emojiDesktop}`}>
                    {item.desktopEmoji || item.emoji}
                </span>
                <List1 className={styles.textDefault} sx={{
                    '@media (min-width: 576px) and (max-width: 767px)': {
                        color: COLORS.BLACK,
                    },
                }}>
                    {typografText(item.text)}
                </List1>
                <List1 className={styles.textDesktop}>
                    {typografText(item.text)}
                </List1>
            </div>
            <a className={styles.link} href={PARTNER_REGISTER_LINK} rel="noreferrer" target="_blank">
                {typografText('Become a partner')}
            </a>
        </div>
    );
}

export default IconTextCard
